<template>
  <v-row
    class="pa-4"
    no-gutters>
    <v-col
      cols="3"
      class="pr-4 hide-on-print">
      <v-row class="white pa-2">
        <v-col
          cols="12">
          <search-box
            v-model="search"
            @on-search="fetchPaginate(false, true)" />
        </v-col>
        <v-col
          v-if="!items.length"
          cols="12">
          <v-card
            class="pa-6 elevation-0 d-flex justify-center align-center"
            tile
            style="border-bottom: 1px solid #e0e0e0;"
          >
            ไม่มี Location
          </v-card>
        </v-col>
        <v-col
          v-else
          cols="12"
          style="max-height: 70vh; overflow-y: auto;"
          @scroll.passive="onScroll">
          <v-card
            v-for="(location, index) in items"
            :key="index"
            class="pa-6 elevation-0 d-flex justify-space-between align-center"
            tile
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <span class="text-subtitle-1 font-weight-medium">
              {{ location.name }}
            </span>

            <v-btn
              color="secondary"
              small
              @click="addToPrint(location)"
            >
              Select
            </v-btn>
          </v-card>
        </v-col>
        <v-col
          v-if="loading"
          cols="12">
          <v-card
            class="pa-6 elevation-0 d-flex justify-center align-center"
            tile
            style="border-bottom: 1px solid #e0e0e0;"
          >
            <v-icon
              large
              class="mdi-spin"
              color="primary">
              mdi-loading
            </v-icon>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-col
      cols="9"
      class="pl-4">
      <v-row class="white pa-4">
        <!-- Select QR size -->
        <v-col
          class="hide-on-print d-flex justify-end align-center pa-0 mb-4"
          cols="12"
        >
          <v-btn
            color="green"
            :disabled="!qrList.length"
            @click="downloadCsv(qrList)">
            EXPORT
            <v-icon class="ml-1">
              mdi-file
            </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-select
            v-model="qrSize"
            hide-details
            outlined
            dense
            style="max-width: 300px;"
            :items="withItems"
            item-text="name"
            return-object
            label="QR Size"
            @change="genQrList"
          />
          <v-btn
            class="ml-2"
            :disabled="!qrList.length"
            color="secondary"
            @click="printTable">
            Print A4
          </v-btn>
        </v-col>

        <v-col
          id="print-section"
          cols="12">
          <v-row>
            <v-col
              v-for="(qrInfo, index) in qrList"
              :key="index"
              :cols="qrSize.value === 70 ? 6 : 12"
              style="border: 1px solid #000; page-break-inside: avoid;"
            >
              <v-row
                class="justify-center align-center">
                <!-- Text left -->
                <v-col
                  class=" pb-0 hide-on-print text-right"
                  cols="12">
                  <v-btn
                    icon
                    @click="deleteFromPrint(index)">
                    <v-icon color="red">
                      mdi-close
                    </v-icon>
                  </v-btn>
                  <v-divider></v-divider>
                </v-col>
                <v-col
                  cols="7"
                  class="text-left">
                  <span
                    :style="{ fontSize: qrSize.textFontSize + 'px', fontWeight: 'bold' }">
                    {{ qrInfo.name }}
                  </span>
                </v-col>

                <!-- QR right -->
                <v-col
                  cols="5"
                  :class="qrSize.value === 70 ? 'd-flex justify-center' : 'd-flex justify-end'"
                  class="pa-1"
                >
                  <img
                    :src="qrInfo.qrUrl"
                    alt="QR Code"
                    :style="{ width: qrOptions.width + 'px', height: qrOptions.width + 'px' }"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import QRCode from 'qrcode'
import SearchBox from '@/components/SearchBox.vue'
import StockMappingProvider from '@/resources/StockMappingProvider'
import { ExportToCsv } from 'export-to-csv'

const stockMappingService = new StockMappingProvider()

export default {
  components: {
    SearchBox
  },
  data () {
    return {
      qrOptions: {
        errorCorrectionLevel: 'M',
        type: 'image/png',
        quality: 0.9,
        margin: 0,
        width: 70,
        color: { dark: '#000', light: '#fff' }
      },
      qrSize: { name: '3 cm.', value: 70, textFontSize: 24 },
      // 31px = 1cm
      withItems: [
        { name: '3 cm.', value: 70, textFontSize: 24 },
        { name: '5 cm.', value: 158, textFontSize: 48 },
        { name: '7 cm.', value: 220, textFontSize: 58 }
      ],
      loading: false,
      items: [],
      totalPages: 0,
      totalItems: 0,
      query: {
        page: 1,
        limit: 10
      },
      search: '',
      qrList: []
    }
  },
  computed: {
    ...mapGetters({
      printLocations: 'StockMapping/printLocations'
    })
  },
  watch: {
    printLocations: {
      handler (newVal) {
        this.genQrList(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.fetchPaginate(false, true)
  },
  beforeDestroy () {
    this.clearPrintLocation()
  },
  methods: {
    ...mapActions({
      addPrintLocation: 'StockMapping/addPrintLocation',
      deletePrintLocation: 'StockMapping/deletePrintLocation',
      clearPrintLocation: 'StockMapping/clearPrintLocation'
    }),
    async deleteFromPrint (index) {
      this.deletePrintLocation(index)
    },
    addToPrint (location) {
      const isExistingIndex = this.printLocations.findIndex((pl) => pl.id === location.id)
      if (isExistingIndex === -1) {
        this.addPrintLocation(location)
      } else {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'Location นี้อยู่ในรายการปรินท์แล้ว',
          type: 'error'
        })
      }
    },
    printTable () {
      if (!this.qrList.length) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'กรุณาเลือก Location ก่อนพิมพ์',
          type: 'error'
        })
      } else {
        window.print()
      }
    },
    async fetchPaginate (append = false, isClear = false) {
      if (this.loading) return
      if (isClear) {
        this.query.page = 1
        this.totalPages = 0
        this.totalItems = 0
      }
      try {
        this.loading = true
        const { data } = await stockMappingService.getLocationPaginate({
          ...this.query,
          search: this.search
        })

        this.totalPages = data.pages
        this.totalItems = data.total

        if (append) {
          this.items = [...this.items, ...data.results]
        } else {
          this.items = data.results
        }
      } catch (error) {
        console.error('getLocation', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async genQrList () {
      this.qrOptions.width = this.qrSize.value
      const list = await Promise.all(
        this.printLocations.map(async (location) => ({
          name: location.name,
          // ชื่อ location เป็น key กลาง (unique, ไม่สนตัวพิมพ์) → ใช้ชื่อเป็นค่า QR ตรงๆ
          qrUrl: await QRCode.toDataURL(location.name, this.qrOptions),
          qrcode: location.name
        }))
      )
      this.qrList = list
    },
    async onScroll (e) {
      const el = e.target
      const bottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 50

      if (bottom && !this.loading && this.query.page < this.totalPages) {
        this.query.page++
        await this.fetchPaginate(true, false)
      }
    },
    async downloadCsv () {
      const payload = this.qrList.map((re) => ({ name: re.name, qrcode: re.qrcode }))
      const options = {
        filename: 'locations_qrcode',
        showLabels: true,
        useKeysAsHeaders: true
      }
      const csvExporter = new ExportToCsv(options)
      csvExporter.generateCsv(payload)
    }
  }
}
</script>

<style>
/* Print only the QR grid */
@media print {
  @page {
    size: A4 portrait;
    margin: 2mm;
  }
  body {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  .hide-on-print {
    display: none !important;
  }

  .col-9 {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    display: block !important;
  }

  /* Reset Vuetify row spacing */
  #print-section .row {
    margin: 0 !important;
    width: 100% !important;
  }

  #sidebar {
    display: none !important;
  }

  header.v-sheet.theme--light.v-toolbar.v-toolbar--dense.v-app-bar.v-app-bar--fixed {
    display: none !important;
  }

  .hide-on-print,
  .hide-on-print * {
    display: none !important;
    visibility: hidden !important;
    height: 0 !important;
    overflow: hidden !important;
  }

  #app main.v-main {
    padding: 0 !important;
  }
  .v-input__icon--prepend-inner,
  .v-input__icon--append {
    display: none !important;
  }
}
</style>
